import dayjs from 'dayjs';

export enum StatusDisplayEnum {
  NotStarted = 'notStarted',
  Outdated = 'outdated',
  Updated = 'updated',
}

const OUTDATED_THRESHOLD_MONTHS = 6; // 6 months

/**
 * Get the status based on the last updated date and if it is dirty
 * @param isDirty - whether the business function is dirty
 * @param lastUpdated - the last updated date string
 * @returns the status of the business function
 * @throws Error if lastUpdated is not a string
 */
export const getStatusDisplay = (
  isDirty: boolean,
  lastUpdated: string,
): StatusDisplayEnum => {
  if (typeof lastUpdated !== 'string') {
    throw new Error('lastUpdated must be a string');
  }

  const parsedDate = dayjs(lastUpdated);

  if (!parsedDate.isValid()) {
    return StatusDisplayEnum.NotStarted;
  }

  const currentDate = dayjs();
  const monthsDiff = currentDate.diff(parsedDate, 'month', true);

  // Early return for not started case
  if (!isDirty) {
    return StatusDisplayEnum.NotStarted;
  }

  // Determine status based on time difference
  return monthsDiff >= OUTDATED_THRESHOLD_MONTHS
    ? StatusDisplayEnum.Outdated
    : StatusDisplayEnum.Updated;
};
